var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.6654V12.832C11 6.7569 15.9249 1.83203 22 1.83203C28.0751 1.83203 33 6.7569 33 12.832V14.6654H36.6667C37.6792 14.6654 38.5 15.4862 38.5 16.4987V38.4987C38.5 39.5112 37.6792 40.332 36.6667 40.332H7.33333C6.32082 40.332 5.5 39.5112 5.5 38.4987V16.4987C5.5 15.4862 6.32082 14.6654 7.33333 14.6654H11ZM34.8333 18.332H9.16667V36.6654H34.8333V18.332ZM20.1667 28.8414C19.0707 28.2075 18.3333 27.0226 18.3333 25.6654C18.3333 23.6403 19.9749 21.9987 22 21.9987C24.0251 21.9987 25.6667 23.6403 25.6667 25.6654C25.6667 27.0226 24.9293 28.2075 23.8333 28.8414V32.9987H20.1667V28.8414ZM14.6667 14.6654H29.3333V12.832C29.3333 8.78194 26.05 5.4987 22 5.4987C17.9499 5.4987 14.6667 8.78194 14.6667 12.832V14.6654Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.e45a51c606e67e20e2c1d243055bec6a.svg";
export { ForwardRef as ReactComponent };